import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import {
  PreviewContainer,
  PreviewImage,
  ActionButtonWrapper,
  CloseButton,
  ButtonContainer,
  Header,
  Error,
  CropperWrap,
  Helper,
} from './PreviewModal.style'
import Icon from 'components/Icon'
import ButtonCta from 'components/Button/ButtonCta'
import { PATRON_SCAN } from 'utils/constants'
import Cropper from 'react-easy-crop'
import getCroppedImg from 'utils/getCroppedImg'

const PreviewModal = ({
  capturedImage,
  retakePhoto,
  closePreviewModal,
  callPatronScan,
  patronScanError,
  isCallingAPI,
}) => {
  const [croppedImage, setCroppedImage] = useState(null)
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels)
  }, [])

  const showCroppedImage = async () => {
    try {
      const croppedImg = await getCroppedImg(capturedImage, croppedAreaPixels)
      setCroppedImage(croppedImg)
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <PreviewContainer>
      {croppedImage && <Header>{'Cropped Image Preview'}</Header>}
      {!croppedImage && <Header>{'Crop the Image'}</Header>}

      {!croppedImage && (
        <CropperWrap>
          <Cropper
            image={capturedImage}
            crop={crop}
            zoom={zoom}
            aspect={4 / 3}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
          />
        </CropperWrap>
      )}

      {croppedImage && <PreviewImage src={croppedImage} alt="Captured" />}

      <ActionButtonWrapper>
        {!croppedImage && (
          <ButtonContainer>
            <ButtonCta type="button" theme="primary" onClick={showCroppedImage} fullwidth>
              {`Crop`}
            </ButtonCta>
          </ButtonContainer>
        )}

        {croppedImage && (
          <>
            <ButtonContainer>
              <ButtonCta type="button" theme="primary" onClick={retakePhoto} fullwidth>
                {'Retake and Crop'}
              </ButtonCta>
            </ButtonContainer>
            <ButtonContainer>
              <ButtonCta
                type="button"
                theme="primary"
                onClick={() => callPatronScan(croppedImage)}
                fullwidth
                isLoading={isCallingAPI}
              >
                {PATRON_SCAN.submit}
              </ButtonCta>
            </ButtonContainer>
          </>
        )}
      </ActionButtonWrapper>
      {!croppedImage && <Helper>{'drag and zoom on the image and click crop for cropping'}</Helper>}
      {patronScanError?.description && <Error>{patronScanError?.description}</Error>}

      <CloseButton onClick={() => closePreviewModal()}>
        <Icon icon={'cross-orange'} customSize="80px" />
      </CloseButton>
    </PreviewContainer>
  )
}

PreviewModal.propTypes = {
  capturedImage: PropTypes.any,
  closePreviewModal: PropTypes.func,
  retakePhoto: PropTypes.func,
  callPatronScan: PropTypes.func,
  patronScanError: PropTypes.object,
  isCallingAPI: PropTypes.bool,
}

export default PreviewModal
